import { useEffect } from 'react';
import { useAuth } from '@/modules/auth/useAuth';
import { getSupabase } from '@/lib/supabase';

const HEARTBEAT_MS = 60_000;

export const usePresenceHeartbeat = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    const supabase = getSupabase();
    if (!supabase) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const db = supabase as any;
    const ping = (presence: 'live' | 'recent') =>
      db
        .from('app_profiles')
        .update({ presence, last_active: new Date().toISOString() })
        .eq('owner_id', user.id)
        .then(() => {});

    ping('live');
    const interval = setInterval(() => ping('live'), HEARTBEAT_MS);

    return () => {
      clearInterval(interval);
      ping('recent');
    };
  }, [user?.id]);
};
